export const LAYOUT_CLASSES = {
  STACKED: "justify-center",
  SIDE_BY_SIDE: "gap-4",
} as const;
